<template>
  <section class="section section--secondary  detail iframe-view"
    :class="{'is-admin': isAdmin, 'is-pos': isPos}"
    id="tickets"
    :style="tenantId == 70 ? 'background:#E5E7E7' : ''"
    dusk="seat-picker">
    <div class="section__inner  section__inner--quaternary" :style="(!isAdmin && $root.isMobile && singleOption) ? 'height: 0; padding: 0' : ''">
      <div :class="{
        'container': !isPos,
        }">
        <h2 class="title  title--primary" :style="($root.isMobile && singleOption) ? 'display: none' : ''">
          <span class="title__inner  title__inner--secondary" :style="tenantId == 70 ? 'background:#E5E7E7' : ''">{{ __('Select Tickets') }}</span>
        </h2>
        <div
          class="picker"
          :class="{
            'allow-excluded': allowExcluded,
            'dont-allow-excluded': !allowExcluded,
            'picker--is-pos': isPos,
          }"
          v-if="showPicker"
        >
          <div class="detail__block">
            <div class="detail__block__inner">
              <div class="picker__seats__inner" style="max-height: initial">
                <app-tabs-wrapper
                  :default="hasSeated && tenantId != 158 ? 'seating' : 'standing'"
                  class="picker__seats__tabs"
                >
                  <div class="picker__seats__tabs__options" slot-scope="slotProps" :style="(!isAdmin && $root.isMobile && singleOption && !$website.iframeView) ? 'display: none' : ''">
                    <app-tabs-trigger
                      name="standing"
                      v-if="
                        !disableTicketsTab &&
                        selectableTickets &&
                        selectableTickets.length > 0
                      "
                      :handle-click="slotProps.toggle"
                      :active="slotProps.active"
                      :opened="$root.buyTickets.opened"
                    >
                      <i class="fas fa-male"></i>
                      <span>{{ __(standingTitle) }}</span>
                    </app-tabs-trigger>
                    <app-tabs-trigger
                      name="seating"
                      :handle-click="slotProps.toggle"
                      :active="slotProps.active"
                      :opened="$root.buyTickets.opened"
                      v-if="hasSeated"
                    >
                      <i class="fas fa-chair"></i>
                      <span>{{ __(seatingTitle) }}</span>
                    </app-tabs-trigger>
                    <app-tabs-trigger
                      name="best"
                      v-if="schedule.bestAvailable.length > 0"
                      :handle-click="slotProps.toggle"
                      :active="slotProps.active"
                      :opened="$root.buyTickets.opened"
                    >
                      <i class="fas fa-star"></i>
                      <span>{{ __("Best Available") }}</span>
                    </app-tabs-trigger>
                  </div>
                  <div slot="items" slot-scope="slotProps">
                    <app-tabs-content
                      name="standing"
                      v-if="
                        !disableTicketsTab &&
                        selectableTickets &&
                        selectableTickets.length > 0
                      "
                      :active="slotProps.active"
                      :isAdmin="isAdmin"
                      :opened="$root.buyTickets.opened"
                      :handle-close="slotProps.close"
                      :tickets="tickets"
                      :tenantId="tenantId"
                    >
                      <div
                        class="picker__seats__inner responsive-table"
                        style="max-height: initial"
                      >
                        <table style="table-layout: fixed">
                          <tbody>
                            <template v-for="(variant, i) in selectableTickets">
                              <tr
                                :key="i"
                                v-if="
                                  (!variant.hide_from_frontend || isAdmin) &&
                                  !variant.block_assignment
                                "
                              >
                                <td class="text-left text-darker responsive-table__col">
                                  <span
                                    v-html="variant.type"
                                    v-bind:style="{
                                      fontSize: tenantId == 97 ? '1.2em' : '1em',
                                      fontWeight: 'bold'
                                    }"
                                    ></span>
                                  <div class="text-black" v-if="variant.description" v-html="variant.description"></div>
                                  <div v-if="variant.document">
                                    <a
                                      target="_blank"
                                      class="underline"
                                      :href="variant.document"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        style="
                                          width: 15px;
                                          height: 15px;
                                          transform: translateY(2px);
                                        "
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                        />
                                      </svg>
                                      <template v-if="tenantId == 106">
                                        Click for Seat Map
                                      </template>
                                      <template v-else> Download attachment </template>
                                    </a>
                                  </div>
                                  <template v-if="!isPos">
                                    <span v-if="variant.booking_fee_display_mode === 'combined_with_breakdown'" v-html="variant.price_human_with_booking_fee" class="responsive-table__display">
                                    </span>
                                    <span v-if="variant.booking_fee_display_mode !== 'combined_with_breakdown'" v-html="variant.price_human" class="responsive-table__display">
                                    </span>
                                    <span v-if="variant.booking_fee_display_mode === 'combined_with_breakdown'" style="font-size:11px; text-transform: none;" class="responsive-table__display">
                                        Incl. <span v-html="variant.booking_fee_human"></span> fees
                                    </span>
                                  </template>
                                </td>
                                <td class="price responsive-table__hide">
                                  <span v-if="variant.booking_fee_display_mode === 'combined_with_breakdown'" v-html="variant.price_human_with_booking_fee">
                                  </span>
                                  <span v-if="variant.booking_fee_display_mode !== 'combined_with_breakdown'" v-html="variant.price_human">
                                  </span>
                                  <span v-if="variant.booking_fee_display_mode === 'combined_with_breakdown'" style="white-space: pre-line; font-size:11px; text-transform: none;">
                                      Incl. <span v-html="variant.booking_fee_human"></span> fees
                                  </span>
                                </td>
                                <td
                                  class="responsive-table__col text-darker"
                                  v-if="requiresVariantMetadataColumn"
                                >
                                  <seat-picker-metadata-info :variant="variant" />
                                </td>
                                <td class="responsive-table__col">
                                  <span
                                    v-if="
                                      variant.available > 0 &&
                                      (!schedule.is_sold_out ||
                                        variant.excluded_capacity)
                                    "
                                    class="qty text-darker"
                                    >{{ __("Quantity") }}</span
                                  >
                                  <div
                                    v-if="
                                      variant.available > 0 &&
                                      (!schedule.is_sold_out ||
                                        variant.excluded_capacity)
                                    "
                                    class="qty_options"
                                  >
                                    <span
                                      class="qty_options__option"
                                      @click="downQty(i)"
                                      v-if="variant.selectedQty > 1"
                                    >
                                      <svg
                                        version="1.1"
                                        width="10px"
                                        height="10px"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 42 42"
                                        style="enable-background: new 0 0 42 42"
                                        xml:space="preserve"
                                      >
                                        <rect y="19" width="42" height="4" stroke="white" stroke-width="4px" />
                                      </svg>
                                    </span>
                                    <span
                                      class="
                                        qty_options__option
                                        qty_options__option--disabled
                                      "
                                      v-else
                                    >
                                      <svg
                                        version="1.1"
                                        width="10px"
                                        height="10px"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 42 42"
                                        style="enable-background: new 0 0 42 42"
                                        xml:space="preserve"
                                      >
                                        <rect y="19" width="42" height="4" stroke="white" stroke-width="4px" />
                                      </svg>
                                    </span>
                                    <span
                                      class="qty_options__number"
                                      v-html="variant.selectedQty"
                                      v-if="!isAdmin"
                                    />
                                    <span v-else>
                                        <input class="qty_options__input"
                                            type="number"
                                            v-model="variant.selectedQty"
                                            @change="applyQtyBounds(i)"
                                        />
                                    </span>
                                    <span
                                      class="qty_options__option"
                                      @click="upQty(i)"
                                      v-if="variant.selectedQty < variant.available && variant.selectedQty < maxTicketsAddQty"
                                    >
                                      <svg
                                        version="1.1"
                                        width="10px"
                                        height="10px"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 42 42"
                                        style="enable-background: new 0 0 42 42"
                                        xml:space="preserve"
                                      >
                                        <polygon
                                          points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " stroke="white" stroke-width="4px"
                                        />
                                      </svg>
                                    </span>
                                    <span
                                      class="
                                        qty_options__option
                                        qty_options__option--disabled
                                      "
                                      v-else
                                    >
                                      <svg
                                        version="1.1"
                                        width="10px"
                                        height="10px"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 42 42"
                                        style="enable-background: new 0 0 42 42"
                                        xml:space="preserve"
                                      >
                                        <polygon
                                          points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " stroke="white" stroke-width="4px"
                                        />
                                      </svg>
                                    </span>
                                  </div>
                                </td>
                                <td
                                  v-if="!isPos && (isAdmin || $website.tenant_settings.ticket_types_show_ticket_count)"
                                  class="text-center responsive-table__hide"
                                  v-bind:class="{
                                    picker__seats__lowqty: variant.available <= 3,
                                  }"
                                >
                                  <span
                                    v-if="variant.available <= 2"
                                    class="qty text-darker"
                                    >Remaining</span
                                  >
                                  <span v-if="variant.available > 2"
                                    >Available</span
                                  >
                                  <span v-else>{{ Math.max(variant.available, 0) }}</span>
                                </td>
                                <td class="text-right width150 responsive-table__col picker__add-ticket">
                                  <button
                                    v-if="
                                      variant.available > 0 &&
                                      (!schedule.is_sold_out ||
                                        variant.excluded_capacity) &&
                                      variant.options
                                    "
                                    class="btn btn--quaternary"
                                    style="padding: 10px"
                                    @click="chooseTicketOptions(variant, i)"
                                  >
                                    {{ __("Add") }}
                                  </button>
                                  <button
                                    v-else-if="
                                      variant.available > 0 &&
                                      (!schedule.is_sold_out ||
                                        variant.excluded_capacity) &&
                                      !variant.options
                                    "
                                    class="btn btn--quaternary btn-add-ticket"
                                    style="padding: 10px"
                                    @click="addTicket(variant, i)"
                                  >
                                    {{ __("Add") }}
                                  </button>
                                  <template v-else>
                                    <span style="color: red">{{
                                      [63, 150, 151].includes(tenantId)
                                        ? "OUT OF STOCK"
                                        : schedule.sold_out_text ||
                                          event.sold_out_text ||
                                          __("SOLD OUT")
                                    }}</span>
                                    <button
                                      @click="outOfStockTicket = variant"
                                      class="btn btn--quaternary mt-2"
                                      v-if="$website.tenant_settings.klaviyo_enabled && !isAdmin"
                                    >
                                      Get notified
                                    </button>
                                  </template>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </app-tabs-content>
                    <app-tabs-content
                      name="seating"
                      :isAdmin="isAdmin"
                      :active="slotProps.active"
                      :opened="$root.buyTickets.opened"
                      :handle-close="slotProps.close"
                      :selected="selected"
                      :tenantId="tenantId"
                    >
                      <!-- Seated -->
                      <div class="wrapper">
                        <div class="row row--reset">
                          <div
                            :class="{
                              'col--6 col--right': !hasSeatmap,
                              'col--12': hasSeatmap,
                            }"
                            class="col mq-desk--12"
                          >
                            <div class="col__inner">
                              <slot name="seated-section-top"></slot>
                              <div v-if="loading" class="loader">
                                <div class="lds-grid">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </div>
                              <div class="svg-seating">
                                <component
                                  :is="venue.seating_block + '-stadium'"
                                  v-if="isStadium"
                                  :blocks="stadiumBlocks"
                                  @selected="selectBlock"
                                  :loading="loading"
                                  :seatsList="seats"
                                  :seatsListSelected="selected"
                                  v-on:selected-seat="add"
                                  @hasSeatmap="seatmap"
                                  :variations="variations"
                                  :venue="venue"
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="blockLevelTickets"
                            class="col col--6 mq-desk--12 col--left"
                          >
                            <div class="col__inner">
                              <p class="mb0" v-if="form.block == '0'">
                                <em
                                  >Please select a
                                  {{
                                    venue.is_table ? venue.aka_table : venue.aka_block
                                  }}
                                  from the layout below in order to acquire
                                  tickets.</em
                                >
                              </p>

                              <div
                                class="picker__seats__inner responsive-table"
                                v-if="selectableTickets.length > 0"
                              >
                                <table style="table-layout: fixed">
                                  <tbody>
                                    <template v-for="(variant, i) in selectableTickets">
                                        <tr
                                        :key="i"
                                        v-if="
                                            (!variant.hide_from_frontend || isAdmin) &&
                                            variant.block_assignment &&
                                            variant.block_assignment == form.block
                                        "
                                        >
                                        <td
                                            class="
                                            text-left text-darker
                                            responsive-table__col
                                            "
                                        >
                                            <span
                                            v-html="variant.type"
                                            v-bind:style="{
                                                fontSize:
                                                tenantId == 97 ? '1.2em' : '1em',
                                                fontWeight: 'bold',
                                            }"
                                            ></span>
                                            <div
                                            class="text-black"
                                            v-if="variant.description"
                                            >
                                            {{ variant.description }}
                                            </div>
                                            <div v-if="variant.document">
                                            <a
                                                target="_blank"
                                                class="underline"
                                                :href="variant.document"
                                            >
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                style="
                                                    width: 15px;
                                                    height: 15px;
                                                    transform: translateY(2px);
                                                "
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                />
                                                </svg>

                                                Download attachment
                                            </a>
                                            </div>
                                            <span
                                            class="responsive-table__display"
                                            v-html="
                                                currency.symbol +
                                                variant.price_human.replace('£', '')
                                            "
                                            ></span>
                                        </td>
                                        <td
                                            v-html="
                                            currency.symbol +
                                            variant.price_human.replace('£', '')
                                            "
                                            class="price responsive-table__hide"
                                        ></td>
                                        <td class="responsive-table__col picker__quantity">
                                            <span
                                            v-if="
                                                variant.available > 0 &&
                                                (!schedule.is_sold_out ||
                                                variant.excluded_capacity)
                                            "
                                            class="qty text-darker"
                                            >{{ __("Quantity") }}</span
                                            >
                                            <div
                                            v-if="
                                                variant.available > 0 &&
                                                (!schedule.is_sold_out ||
                                                variant.excluded_capacity)
                                            "
                                            class="qty_options"
                                            >
                                            <span
                                                class="qty_options__option"
                                                @click="downQty(i)"
                                                v-if="variant.selectedQty > 1"
                                            >
                                                <svg
                                                version="1.1"
                                                width="10px"
                                                height="10px"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 42 42"
                                                style="enable-background: new 0 0 42 42"
                                                xml:space="preserve"
                                                >
                                                <rect y="19" width="42" height="4" stroke="white" stroke-width="4px" />
                                                </svg>
                                            </span>
                                            <span
                                                class="
                                                qty_options__option
                                                qty_options__option--disabled
                                                "
                                                v-else
                                            >
                                                <svg
                                                version="1.1"
                                                width="10px"
                                                height="10px"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 42 42"
                                                style="enable-background: new 0 0 42 42"
                                                xml:space="preserve"
                                                >
                                                <rect y="19" width="42" height="4" stroke="white" stroke-width="4px" />
                                                </svg>
                                            </span>
                                            <span
                                                class="qty_options__number"
                                                v-html="variant.selectedQty"
                                            />
                                            <span
                                                class="qty_options__option"
                                                @click="upQty(i)"
                                                v-if="
                                                variant.selectedQty < variant.available && varuant.selectedQty < maxTicketsAddQty
                                                "
                                            >
                                                <svg
                                                version="1.1"
                                                width="10px"
                                                height="10px"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 42 42"
                                                style="enable-background: new 0 0 42 42"
                                                xml:space="preserve"
                                                >
                                                <polygon
                                                    points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " stroke="white" stroke-width="4px"
                                                />
                                                </svg>
                                            </span>
                                            <span
                                                class="
                                                qty_options__option
                                                qty_options__option--disabled
                                                "
                                                v-else
                                            >
                                                <svg
                                                version="1.1"
                                                width="10px"
                                                height="10px"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 42 42"
                                                style="enable-background: new 0 0 42 42"
                                                xml:space="preserve"
                                                >
                                                <polygon
                                                    points="42,20 22,20 22,0 20,0 20,20 0,20 0,22 20,22 20,42 22,42 22,22 42,22 " stroke="white" stroke-width="4px"
                                                />
                                                </svg>
                                            </span>
                                            </div>
                                        </td>
                                        <td
                                            class="text-center responsive-table__hide picker__remaining"
                                            v-bind:class="{
                                            picker__seats__lowqty:
                                                variant.available <= 3,
                                            }"
                                        >
                                          <span
                                          v-if="variant.available <= 2"
                                          class="qty text-darker"
                                          >Remaining</span
                                          >
                                          <span v-if="variant.available > 2"
                                          >Available</span
                                          >
                                          <span v-else>{{
                                          Math.max(variant.available, 0)
                                          }}</span>
                                        </td>
                                        <td
                                            class="
                                            text-right
                                            width150
                                            responsive-table__col
                                            "
                                        >
                                            <button
                                            v-if="
                                                variant.available > 0 &&
                                                (!schedule.is_sold_out ||
                                                variant.excluded_capacity) &&
                                                variant.options
                                            "
                                            class="btn btn--quaternary"
                                            style="padding: 10px"
                                            @click="chooseTicketOptions(variant, i)"
                                            >
                                            {{ __("Add") }}
                                            </button>
                                            <button
                                            v-else-if="
                                                variant.available > 0 &&
                                                (!schedule.is_sold_out ||
                                                variant.excluded_capacity) &&
                                                !variant.options
                                            "
                                            class="btn btn--quaternary"
                                            style="padding: 10px"
                                            @click="addTicket(variant, i)"
                                            >
                                            {{ __("Add") }}
                                            </button>
                                            <template v-else>
                                            <span style="color: red">{{
                                                [63, 150, 151, 181, 182, 183].includes(tenantId)
                                                ? "OUT OF STOCK"
                                                : schedule.sold_out_text ||
                                                    event.sold_out_text ||
                                                    __("SOLD OUT")
                                            }}</span>
                                            <button
                                                @click="outOfStockTicket = variant"
                                                class="btn btn--quaternary mt-2"
                                                v-if="
                                                ([63, 150, 151, 181, 182, 183].includes(tenantId) ||
                                                    website.env !== 'production') &&
                                                !isAdmin
                                                "
                                            >
                                                Get notified
                                            </button>
                                            </template>
                                        </td>
                                        </tr>
                                    </template>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div
                            v-else-if="!hasSeatmap"
                            class="col col--6 mq-desk--12 col--left"
                          >
                            <div class="col__inner">
                              <p class="mb0" v-if="form.block == '0'">
                                <em
                                  >Please select a
                                  {{
                                    venue.is_table ? venue.aka_table : venue.aka_block
                                  }}
                                  from the layout below in order to acquire
                                  tickets.</em
                                >
                              </p>

                              <div
                                class="
                                  picker__seats__inner
                                  responsive-table
                                  tableLayout
                                "
                                v-if="seats.length > 0"
                              >
                                <table>
                                  <tbody>
                                    <tr
                                      v-for="(seat, index) in seats"
                                      :key="index"
                                      v-bind:class="{
                                        active:
                                          selectedIndexes.indexOf(
                                            seat.block_id +
                                              '-' +
                                              seat.row_id +
                                              '-' +
                                              seat.seat
                                          ) != -1,
                                      }"
                                      v-bind:style="{
                                        background: seat.booked
                                          ? seat.colours && seat.colours.booked
                                            ? seat.colours.booked
                                            : '#a1a1a1'
                                          : seat.excluded
                                          ? seat.colours && seat.colours.unavailable
                                            ? seat.colours.unavailable
                                            : '#cccccc'
                                          : '',
                                      }"
                                    >
                                      <td
                                        v-if="
                                          seat.variations &&
                                          seat.variations.length > 1
                                        "
                                        :data-header="__('Type')"
                                      >
                                        <select @change="updateSeat($event, index)">
                                          <option
                                            v-for="(
                                              seatVariation, seatVariationIndex
                                            ) in seat.variations"
                                            :value="seatVariationIndex"
                                            v-html="seatVariation.name"
                                            :key="seatVariationIndex"
                                          ></option>
                                        </select>
                                      </td>
                                      <td
                                        v-else-if="
                                          seat.variations &&
                                          seat.variations.length == 1
                                        "
                                        :data-header="__('Type')"
                                      >
                                        {{ seat.variations[0].name }}
                                      </td>
                                      <td
                                        :data-header="
                                          !venue.is_table ? __('Block') : __('Table')
                                        "
                                        v-html="seat.block"
                                        class="responsive-table__col"
                                      ></td>
                                      <td
                                        :data-header="venue.aka_row"
                                        v-if="!venue.is_table"
                                        v-html="seat.row"
                                        class="responsive-table__col"
                                      ></td>
                                      <td
                                        :data-header="venue.aka_seat"
                                        v-html="seat.seat"
                                        class="responsive-table__col"
                                      ></td>
                                      <td
                                        v-if="!isGateshead"
                                        :data-header="__('Price')"
                                        class="
                                          price
                                          responsive-table__col
                                          responsive-table__col--secondary
                                        "
                                        v-html="currency.symbol + seat.price_human"
                                      ></td>
                                      <td v-else>
                                        <select
                                          v-model="seat.option"
                                          style="border: 0px; width: 110px"
                                        >
                                          <option value="Adult|||220.00">
                                            Adult - £220
                                          </option>
                                          <option value="Adult Renewal|||195.00">
                                            Adult Renewal - £195
                                          </option>
                                          <option value="Concession|||140.00">
                                            Concession - £140
                                          </option>
                                          <option value="Concession Renewal|||125.00">
                                            Concession Renewal - £125
                                          </option>
                                          <option value="young|||120.00">
                                            Young adult (U19 - 16) - £120
                                          </option>
                                          <option value="U16|||40.00">
                                            U16 - 11 - £40
                                          </option>
                                          <option value="U11|||0.00">
                                            Under 11 - Free
                                          </option>
                                        </select>
                                      </td>
                                      <td
                                        @click.prevent="add(seat)"
                                        class="
                                          text-center
                                          responsive-table__col
                                          responsive-table__col--secondary
                                        "
                                      >
                                        <button
                                          type="button"
                                          class="btn btn--quaternary"
                                          v-html="
                                            selectedIndexes.indexOf(
                                              seat.block_id +
                                                '-' +
                                                seat.row_id +
                                                '-' +
                                                seat.seat
                                            ) != -1
                                              ? __('Remove from basket')
                                              : __('Add to basket')
                                          "
                                        ></button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </app-tabs-content>
                    <app-tabs-content
                      name="best"
                      :isAdmin="isAdmin"
                      :active="slotProps.active"
                      :opened="$root.buyTickets.opened"
                      :handle-close="slotProps.close"
                      :selected="selected"
                      :tenantId="tenantId"
                    >
                      <!-- Best Available -->
                      <div class="detail__type">{{ __("Best Available") }}</div>
                      <div
                        class="picker__seats__inner"
                        v-if="schedule.bestAvailable.length > 0"
                      >
                        <table>
                          <tbody>
                            <tr
                              v-for="(seat, index) in schedule.bestAvailable"
                              :key="index"
                              @click="add(seat)"
                              v-bind:class="{
                                active:
                                  selectedIndexes.indexOf(
                                    seat.block_id +
                                      '-' +
                                      seat.row_id +
                                      '-' +
                                      seat.seat
                                  ) != -1,
                              }"
                              v-bind:style="{
                                background: seat.booked
                                  ? seat.colours && seat.colours.booked
                                    ? seat.colours.booked
                                    : '#a1a1a1'
                                  : seat.excluded
                                  ? seat.colours && seat.colours.unavailable
                                    ? seat.colours.unavailable
                                    : '#cccccc'
                                  : '',
                              }"
                            >
                              <td
                                :data-header="
                                  !venue.is_table ? venue.aka_block : venue.aka_table
                                "
                                v-html="seat.block"
                              ></td>
                              <td
                                :data-header="venue.aka_row"
                                v-if="!venue.is_table"
                                v-html="seat.row"
                              ></td>
                              <td
                                :data-header="venue.aka_seat"
                                v-html="seat.seat"
                              ></td>
                              <td
                                :data-header="__('Price')"
                                class="price"
                                v-html="currency.symbol + seat.price_human"
                              ></td>
                              <td class="text-center">
                                <button
                                  type="button"
                                  class="btn btn--quaternary"
                                  v-html="
                                    selectedIndexes.indexOf(
                                      seat.block_id +
                                        '-' +
                                        seat.row_id +
                                        '-' +
                                        seat.seat
                                    ) != -1
                                      ? __('Remove')
                                      : __('Add')
                                  "
                                ></button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <p v-else>
                        {{
                          __(
                            "We always want to offer you the best available tickets, these tickets may become available again soon... Watch this space!"
                          )
                        }}
                      </p>
                    </app-tabs-content>
                  </div>
                </app-tabs-wrapper>
              </div>
            </div>
          </div>
          <seat-picker-modal
            v-if="showTicketOptionsModal && activeTicket"
            :activeTicket="activeTicket"
            @close="activeTicket = null"
            @addToBasket="addActiveTicketMultiple"
          />

          <out-of-stock-modal
            v-if="outOfStockTicket"
            :activeTicket="outOfStockTicket"
            :event="event"
            :schedule="schedule"
            :venue="venue"
            @close="outOfStockTicket = null"
          />

          <seat-picker-seat-added-modal
            v-if="showSeatAddedModal"
            @close="showSeatAddedModal = false"
            :order-id="orderId"
          />

          <seat-picker-acknowledgement-modal
            v-if="showAcknowledgementModal && activeTicket"
            :activeTicket="activeTicket"
            @close="showAcknowledgementModal = false"
            @accept="acceptAcknowledgement"
          />

          <seat-picker-ticket-variant-seated-adjacent-unavailable-modal
            v-if="showTicketVariantSeatsAdjacentUnavailableModal && activeTicket"
            :activeTicket="activeTicket"
            @close="showTicketVariantSeatsAdjacentUnavailableModal = false"
            @accept="acceptUnadjacentSeats"
          />
        </div>
        <div v-else>
          <p class="text-black text-center text-2xl">There are currently no tickets on sale. Please check back later</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TabsWrapper from "./Tabs/Wrapper";
import TabsTrigger from "./Tabs/Trigger";
import TabsContent from "./Tabs/Content";
import SeatPickerModal from "./SeatPickerModal.vue";
import SeatPickerSeatAddedModal from "./SeatPickerSeatAddedModal.vue";
import SeatPickerAcknowledgementModal from "./SeatPickerAcknowledgementModal.vue";
import SeatPickerTicketVariantSeatedAdjacentUnavailableModal from "./SeatPickerTicketVariantSeatedAdjacentUnavailableModal.vue";
import OutOfStockModal from "./OutOfStockModal.vue";

export default {
  components: {
    "app-tabs-wrapper": TabsWrapper,
    "app-tabs-trigger": TabsTrigger,
    "app-tabs-content": TabsContent,
    "seat-picker-modal": SeatPickerModal,
    "seat-picker-seat-added-modal": SeatPickerSeatAddedModal,
    "seat-picker-acknowledgement-modal": SeatPickerAcknowledgementModal,
    "seat-picker-ticket-variant-seated-adjacent-unavailable-modal": SeatPickerTicketVariantSeatedAdjacentUnavailableModal,
    "out-of-stock-modal": OutOfStockModal,
  },

  props: {
    frontEnd: {
      type: Boolean,
      default: true
    },
    isStadium: {
      type: Boolean,
      default: false,
    },
    hasSeated: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      required: true,
    },
    venue: {
      type: Object,
      required: true,
    },
    schedule: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    block: {
      require: true,
    },
    addToBasketMessage: {
      type: String,
      required: false,
      default: "The ticket has been added to your basket.",
    },
    removeFromBasketMessage: {
      type: String,
      required: false,
      default: "The ticket has been removed from your basket.",
    },
    unavailableMessage: {
        type: String,
        required: false,
        default: 'The selected tickets are no longer available.'
    },
    standingTitle: {
      type: String,
      required: false,
      default: "Standing",
    },
    seatingTitle: {
      type: String,
      required: false,
      default: "Seating",
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPos: {
      type: Boolean,
      required: false,
      default: false,
    },
    orderId: {
      type: Number,
      required: false,
      default: null,
    },
    tenantId: {
      type: Number,
      required: false,
      default: 7,
    },
  },
  computed: {
    showPicker() {
      return this.hasSeated || this.selectableTickets.length;
    },
    isGateshead() {
      return this.venue.id == 109 || this.venue.id == 121;
    },
    allowExcluded() {
      return this.isAdmin;
    },
    allowHidden() {
      return this.isAdmin;
    },
    disableTicketsTab() {
      var disable = true;
      if (this.selectableTickets.length > 0) {
        this.selectableTickets.forEach((value, key) => {
          if (!value.block_assignment) {
            disable = false;
          }
        });
      }
      return disable;
    },
    singleOption() {
        let optionsCount = 0;
        if (this.schedule.tickets.length > 0) {
            optionsCount++;
            this.tabToBeOpened = 'standing';
        }
        if (this.hasSeated) {
            optionsCount++;
            this.tabToBeOpened = 'seating';
        }
        if (this.schedule.bestAvailable.length > 0) {
            optionsCount++;
            this.tabToBeOpened = 'best';
        }
        if (optionsCount === 1) {
            return true;
        }
        return false;
    }
  },
  data: () => ({
    website: window.website,
    loading: true,
    currency: window.currency,
    maxTicketsAddQty: 200,

    form: {
      block: "0",
    },

    blockLevelTickets: false,
    blocks: [],
    stadiumBlocks: {},
    seats: [],
    selectableTickets: [],
    hasSeatmap: false,
    selectedMerchandise: [],
    selected: [],
    selectedIndexes: [],
    selectedErrors: [],

    tickets: [],
    individualTickets: null,
    ticketsErrors: [],
    activeTicket: null,
    activeTicketIndex: null,
    outOfStockTicket: null,

    ticketsAddedToBasketCount: 0,
    variations: [],
    showSeatAddedModal: false,
    showTicketOptionsModal: false,
    showAcknowledgementModal: false,
    showTicketVariantSeatsAdjacentUnavailableModal: false,

    requiresVariantMetadataColumn: false,
  }),

  mounted() {
    //list of available variations for this schedule, and remove hidden if they are not allowed
    let variations = this.schedule.variable_seat_pricing != 0 ? this.schedule.variable_seat_pricing_config : [];

    variations = variations.filter((variation) => {
      return !variation.hide_from_frontend || this.allowHidden;
    });
    this.variations = variations;

    if (this.schedule.tickets) {
      const urlParts = location.href.split('/');
      var subpath = null;
      if (urlParts[urlParts.length - 3] === this.$website.tenant_settings.events_slug) {
        subpath = urlParts[urlParts.length - 1].split('?')[0];
        if (['iframe-view'].includes(subpath)) {
            subpath = null;
        }
      }

      this.schedule.tickets.forEach((ticket) => {
        if (this.isAdmin || (!ticket.hide_from_frontend && (
            (!subpath && !ticket.private_path) ||
            (subpath && ticket.private_path == subpath)
        ))) {
          this.selectableTickets.push({
            ...ticket,
            ...{ originalAvailable: ticket.available, selectedQty: 1, qty: 1 },
          });
          if (ticket.metadata) {
            this.requiresVariantMetadataColumn = true;
          }
        }
      });
    }

    this.getBlocks();

    if (
      this.venue.table_layout &&
      this.venue.table_layout != 0 &&
      typeof this.block !== "undefined"
    ) {
      this.form.block = this.block;

      this.getSeats();
    }
  },

  methods: {
    ghOption(seat) {
      var answ = seat.option.split("|||");
      return answ[0] + " - £" + answ[1];
    },
    selectBlock(index) {
      this.form.block = "0";

      for (let i in this.blocks) {
        var block = this.blocks[i];

        if (block.name == index) {
          this.form.block = block.id;
          break;
        }
      }

      if (!this.stadiumBlocks[index].tickets_attached) {
        this.getSeats();
      } else {
        this.blockLevelTickets = true;
      }
    },
    add(seat) {
      if (!seat.booked && (!seat.excluded || this.isAdmin)) {
        if (
          this.selectedIndexes.indexOf(
            seat.block_id + "-" + seat.row_id + "-" + seat.seat
          ) == -1
        ) {
          this.selectedIndexes.push(
            seat.block_id + "-" + seat.row_id + "-" + seat.seat
          );
          this.selected.push(seat);
          //this.payment();
          this.addToBasket(seat, false);

          this.notify("add");
        } else {
          this.remove(seat);
          this.removeFromBasket(seat, false);
        }
      }
    },
    removeFromBasket(seat, ticket) {
      if (this.ticketsAddedToBasketCount > 0 && ticket.qty) {
        this.ticketsAddedToBasketCount -= ticket.qty;
      }

      if (basketCount) {
        var basketCount = document.getElementById("basketCount");
        basketCount.innerText = Number(basketCount.innerText) - 1;
      }

      axios.post("/basket/remove-seat", {
        schedule_id: this.schedule.id,
        venue_id: this.venue.id,
        event_id: this.event.id,
        seats: seat,
        indexes: this.selectedIndexes,
        tickets: ticket,
        merchandise: this.selectedMerchandise,
        url: this.url,
      });
    },
    chooseTicketOptions(ticket, index) {
      // if the ticket has options set that as the active ticket & modal will show
      if (ticket.options) {
        this.showTicketOptionsModal = true;
        this.activeTicket = ticket;
        this.activeTicketIndex = index;
        return;
      }
    },
    // addActiveTicket(ticket) {
    //     this.addTicket(ticket, this.activeTicketIndex);
    // },
    /**
     * add multiple tickets of the same type.
     * This is used for the ticket options modal where they select options for each ticket
     */
    async addActiveTicketMultiple(tickets) {
      let activeTicketIndex = this.activeTicketIndex;
      if (
        !this.isPos &&
        this.activeTicket.acknowledgement &&
        !this.activeTicket.acknowledgementAccepted
      ) {
        this.individualTickets = tickets;
        this.showAcknowledgementModal = true;
      } else {
        for (let ticket of tickets) {
          await this.addTicket(ticket, activeTicketIndex);
        }
      }
    },
    async acceptAcknowledgement() {
      this.activeTicket.acknowledgementAccepted = true;
      if (this.individualTickets && this.individualTickets.length) {
        await this.addActiveTicketMultiple(this.individualTickets);
      } else {
        this.addTicket(this.activeTicket, this.activeTicketIndex);
      }
      this.individualTickets = null;
    },
    async acceptUnadjacentSeats() {
      this.activeTicket.mustBeAdjacent = false;
      this.addToBasket(false, this.activeTicket);
      this.activeTicket = null;
      this.showTicketVariantSeatsAdjacentUnavailableModal = false;
    },
    async addTicket(ticket, index) {

      // Malta fairyland - PENGUIN'S ICE RINK
      if (ticket.options) {
        ticket.options.forEach((option, optionIndex) => {
          option.choices.forEach((choice, choiceIndex) => {
            if (option.selected && option.selected.available && choice.name == option.selected.name) {
              Vue.set(this.selectableTickets[index].options[optionIndex].choices[choiceIndex], "available", option.selected.available);
            }
          });
        });
      }

      this.showTicketOptionsModal = false;
      this.showAcknowledgementModal = false;
      this.showTicketVariantSeatsAdjacentUnavailableModal = false;
      this.activeTicket = null;
      this.activeTicketIndex = null;

      if (
        !this.isPos &&
        !this.individualTickets &&
        ticket.acknowledgement &&
        !ticket.acknowledgementAccepted
      ) {
        this.activeTicket = ticket;
        this.activeTicketIndex = index;
        this.showAcknowledgementModal = true;
        return;
      }
      ticket.acknowledgementAccepted = false;

      ticket.qty = parseInt(ticket.selectedQty);

      if (!this.isAdmin) {
        // this.tickets contains tickets that have already been added to their basket
        // get the matching ticket if one exists already
        let existingSelectedTicket = this.tickets.find((t, i) => {
          return t.type === ticket.type;
        });

        var totalSelectedQty = parseInt(ticket.selectedQty);
        if(existingSelectedTicket && existingSelectedTicket.selectedQty) {
            totalSelectedQty += parseInt(existingSelectedTicket.selectedQty);
        }
        var quantityErrorMessage = null;
        if (ticket.max_quantity && totalSelectedQty > ticket.max_quantity) {
          quantityErrorMessage = "Please add fewer than " + ticket.max_quantity + " tickets.";
          if (existingSelectedTicket) {
            quantityErrorMessage += " You have already added " + existingSelectedTicket.selectedQty + " tickets.";
          }
        } else if (ticket.min_quantity && totalSelectedQty < ticket.min_quantity) {
          quantityErrorMessage = "Please add a minimum of " + ticket.min_quantity + " tickets!";
        }
        if(quantityErrorMessage) {
          this.$toasted.show(
            quantityErrorMessage,
            {
              theme: "bubble",
              type: "error",
              position: "top-center",
              duration: 3000,
            }
          );
          return;
        }
      }

      // set the qty added to basket and update the remaining available tickets.
      let match = false;
      this.tickets.forEach((t, i) => {
        if (t.type === ticket.type) {
          this.tickets[i].selectedQty = parseInt(this.tickets[i].selectedQty) + parseInt(ticket.selectedQty);
          this.tickets[i].total = this.numberWithCommas((this.tickets[i].price * this.tickets[i].selectedQty).toFixed(2));
          this.selectableTickets[index].available = this.selectableTickets[index].originalAvailable - this.tickets[i].selectedQty;
          if (parseInt(this.tickets[i].selectedQty) + parseInt(ticket.selectedQty) > this.selectableTickets[index].originalAvailable) {
            this.selectableTickets[index].selectedQty = this.selectableTickets[index].originalAvailable - this.tickets[i].selectedQty;
          }
          match = true;
        }
      });

      // if the ticket is not found in the list of booked tickets then add it (and update the remaining qty)
      if (!match) {
        this.tickets.push({
          ...ticket,
          ...{
            selectedQty: parseInt(ticket.selectedQty),
            total: this.numberWithCommas(
              (ticket.price * parseInt(ticket.selectedQty)).toFixed(2)
            ),
          },
        });

        this.selectableTickets[index].available = this.selectableTickets[index].originalAvailable - parseInt(ticket.selectedQty);

        if (parseInt(ticket.selectedQty) * 2 > this.selectableTickets[index].originalAvailable) {
          this.selectableTickets[index].selectedQty = this.selectableTickets[index].originalAvailable - ticket.selectedQty;
        }
      }

      this.ticketsAddedToBasketCount += ticket.qty;

      let success = await this.addToBasket(false, ticket);

      if (success) {
        this.notify('add');
      }

      return true;
    },
    async addToBasket(seat, ticket) {
      var basketCount = document.getElementById("basketCount");
      if (basketCount) {
        basketCount.innerText = Number(basketCount.innerText) + 1;
      }

      if (window._klaviyoHelper) {
        let scheduleDate = new Date(this.schedule.date);
        let scheduleDateStr =
          scheduleDate.getDate() + "/" + (scheduleDate.getMonth() + 1);
        window._klaviyoHelper.recordEvent([
          "track",
          "Add to cart",
          {
            tour: this.event.title,
            event:
              this.event.title +
              " " +
              scheduleDateStr +
              " " +
              this.schedule.location,
            genre: this.event.genre,
            event_name: this.event.title,
            schedule_date: scheduleDateStr,
            venue: this.venue.name,
            ticket_type: ticket.type,
            ticket_price: ticket.price,
            ticket_quantity: ticket.selectedQty,
            imageURL:
              "https://" +
              window.location.hostname +
              "/" +
              this.event.thumbnail,
          },
        ]);
      }

      let url = "/basket/add";
      if (this.isAdmin) {
        window.showLoadingOverlay();
        url =
          "/admin/orders/addtickets/" +
          this.orderId +
          "/" +
          this.event.id +
          "/" +
          this.schedule.id;
      }
      const addToBasketPayload = {
        schedule_id: this.schedule.id,
        venue_id: this.venue.id,
        event_id: this.event.id,
        seats: seat,
        indexes: this.selectedIndexes,
        tickets: ticket,
        merchandise: this.selectedMerchandise,
        url: this.url,
        mustBeAdjacent: ticket.mustBeAdjacent ?? true,
      };

      if (this.$website.iframeView) {
        // if we are in an iframe view then we construct a form and post the tickets in a new tab
        const form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', url);
        form.setAttribute('target', '_blank');

        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'addticketpayload');
        input.setAttribute('value', JSON.stringify(addToBasketPayload));
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

        return;
      }

      let response = await axios.post(url, addToBasketPayload);

      if (response.data.error && response.data.error === 'Adjacent seats unavailable') {
        this.activeTicket = ticket;
        this.showTicketVariantSeatsAdjacentUnavailableModal = true;
        return false;
      }

      if (this.isAdmin) {
        window.hideLoadingOverlay();
        if (response.data.error) {
          alert(response.data.error);
          window.location.reload();
        } else {
            if (!this.isPos) {
                this.showSeatAddedModal = true;
            }
        }
      } else {
        if (response.data.error) {
          this.notify('unavailable');
          return false;
        } else if (response.data.booked) {
          response.data.tickets.forEach((ticket, i) => {
            this.selectableTickets[i].available = ticket.available;
          });
          this.notify('unavailable');
          return false;
        }
      }

      this.$emit('ticketAdded');

      return true;
    },

    applyQtyBounds(index) {
      var maxValue = Math.min(this.maxTicketsAddQty, this.selectableTickets[index].originalAvailable);
      if (this.selectableTickets[index].selectedQty > maxValue) {
        this.selectableTickets[index].selectedQty = maxValue;
      } else if (this.selectableTickets[index].selectedQty < 1) {
        this.selectableTickets[index].selectedQty = 1;
      }
    },

    setQuantity(index, quantity) {
      quantity = parseInt(quantity);
      if (quantity > this.selectableTickets[index].originalAvailable) {
        quantity = this.selectableTickets[index].originalAvailable;
      }
      this.selectableTickets[index].selectedQty = quantity;
    },

    upQty(index) {
      this.setQuantity(index, parseInt(this.selectableTickets[index].selectedQty) + 1);
    },

    downQty(index) {
      this.setQuantity(index, parseInt(this.selectableTickets[index].selectedQty) - 1);
    },

    remove(seat) {
      let vm = this;
      this.selected.forEach(function (s, index) {
        if (
          seat.block_id + "-" + seat.row_id + "-" + seat.seat ==
          s.block_id + "-" + s.row_id + "-" + s.seat
        ) {
          Vue.delete(vm.selected, index);
        }
      });

      this.selectedIndexes.forEach(function (s, index) {
        if (seat.block_id + "-" + seat.row_id + "-" + seat.seat == s) {
          Vue.delete(vm.selectedIndexes, index);
        }
      });

      this.notify("remove");
    },
    getBlocks() {
      this.reset();

      axios
        .post("/events/blocks", {
          schedule_id: this.schedule.id,
          venue_id: this.venue.id,
          event_id: this.event.id,
          allow_excluded: this.allowExcluded,
          allow_hidden: this.allowHidden,
        })
        .then((response) => {
          if (response.data.blocks) {
            for (let i in response.data.blocks) {
              this.blocks.push(response.data.blocks[i]);
            }
          }

          if (response.data.stadiumBlocks) {
            this.stadiumBlocks = response.data.stadiumBlocks;
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    getSeats() {
      this.seats = [];

      if (this.form.block) {
        this.loading = true;

        axios
          .post("/events/seats", {
            schedule_id: this.schedule.id,
            venue_id: this.venue.id,
            event_id: this.event.id,
            block: this.form.block,
            allow_excluded: this.allowExcluded,
            allow_hidden: this.allowHidden,
          })
          .then((response) => {
            if (response.data.seats) {
              this.seats = response.data.seats;
            }

            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      }
    },

    reset() {
      this.loading = true;

      this.form.block = "0";

      this.blocks = [];
      this.seats = [];
      this.selected = [];
      this.selectedIndexes = [];
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    notify: function (state) {
      let msg;
      let type = 'success';

      switch (state) {
        case "add":
          msg = this.__(this.addToBasketMessage);
          break;
        case "remove":
          msg = this.__(this.removeFromBasketMessage);
          break;
        case "unavailable":
          msg = this.__(this.unavailableMessage);
          type = 'error';
          break;
      }

      if (msg && this.$toasted) {
        this.$toasted.show(this.__(msg), {
          theme: "bubble",
          type: type,
          position: "top-center",
          duration: 3000,
        });
      }
    },
    seatmap(seatmap) {
      this.hasSeatmap = seatmap ? true : false;
    },
    updateSeat(event, index) {
      let variationIndex = event.target.value;
      this.seats[index].type = this.seats[index].variations[variationIndex].name;
      this.seats[index].price = this.seats[index].variations[variationIndex].price;
      this.seats[index].price_human = this.seats[index].variations[variationIndex].price_human;
      this.seats[index].attendee_age_type = this.seats[index].variations[variationIndex].attendee_age_type;
      this.seats[index].purchase_requires_an_adult_ticket = this.seats[index].variations[variationIndex].purchase_requires_an_adult_ticket;
    },
  },
  watch: {
    ticketsAddedToBasketCount: {
      handler(val) {
        this.selectableTickets.forEach((t, i) => {
          if (
            this.selectableTickets[i].available >
            this.schedule.total_tickets_remaining - val
          ) {
            this.selectableTickets[i].available =
              this.schedule.total_tickets_remaining - val;
          }
        });
      },
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/base/_variables.scss";
@import "../../sass/mixins/_box-model.scss";
@import "../../sass/mixins/_breakpoint.scss";
@import "../../sass/mixins/_transforms.scss";

.picker {
  display: block;

  &__seats {
    &__tabs {
      display: block;

      &__options {
        font-size: 0;
        text-align: center;

        > * {
          display: inline-block;
          vertical-align: middle;

          &:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }

          &:last-child {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }
        }
      }
    }

    &__lowqty {
      font-weight: 600;
      color: #c70000;
    }

    &__ttl {
      position: relative;

      margin-bottom: 15px;

      font-size: 18px;
      line-height: 18px;
      text-align: center;
      font-weight: 200;
      text-transform: uppercase;
      letter-spacing: 2px;
    }

    &__inner {
      position: relative;

      @media screen and (min-width: $mq-mob) {
        overflow: visible;
        max-height: 300px;
      }

      &.tableLayout {
        overflow: auto;
        max-height: auto !important;
      }

      table {
        width: 100%;
        min-width: 300px;
      }

      table tr.hide-mobile {
        display: none;

        @media screen and (min-width: $mq-mob) {
          display: table-row;
        }
      }

      table td:last-child {
        margin-bottom: 15px;

        @media screen and (min-width: $mq-mob) {
          margin-bottom: 0;
        }
      }

      table td:first-child {
        margin-top: 15px;

        @media screen and (min-width: $mq-mob) {
          margin-top: 0;
        }
      }

      table td,
      table th {
        display: block;
        width: 100%;

        vertical-align: middle;
        padding: 10px 5px;

        text-align: center;
        text-transform: uppercase;
        color: #ccc;

        @media screen and (min-width: $mq-mob) {
          display: table-cell;
          width: auto;
        }

        &.text-darker {
          color: #666666;
        }

        &.text-left {
          text-align: center;

          @media screen and (min-width: $mq-mob) {
            text-align: left;
          }
        }

        &.text-right {
          text-align: center;

          @media screen and (min-width: $mq-mob) {
            text-align: right;
          }
        }

        &.width150 {
          width: 100%;

          @media screen and (min-width: $mq-mob) {
            width: 150px;
          }
        }

        &.price {
          color: $tertiary-colour;
        }
        .qty {
          display: block;
          margin-bottom: 5px;
          color: #666666;
        }
      }

      table td {
        &:before {
          display: block;
          content: attr(data-header);
          font-weight: 500;
          font-size: 75%;
        }
      }

      table th {
        font-weight: light;
        text-transform: uppercase;

        border-bottom: 1px solid #f0f0f0;
      }

      table tr {
        background: $secondary-colour;
      }

      table tbody tr {
        border-bottom: 1px solid #ddd;

        &:not(.active):nth-child(even) {
          background: #fafafa;

          @media screen and (min-width: $mq-mob) {
            background: transparent;
          }
        }
      }

      table tr.active {
        background: $tertiary-colour;

        td {
          color: white;

          .btn--quaternary {
            background: white !important;
            color: $tertiary-colour !important;
          }
        }
      }
    }
  }

  &__chosen {
    &__ttl {
      position: relative;

      margin-bottom: 15px;

      font-size: 18px;
      line-height: 18px;
      text-align: center;
      font-weight: 200;
      text-transform: uppercase;
      letter-spacing: 2px;
    }

    &__btn {
      margin-top: 20px;

      text-align: center;

      @include mq(max-width, 800px) {
        @include position(fixed, auto, 0, 0, 0, 10);

        display: block;
        padding: 20px;

        background: $secondary-colour;

        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.3);
      }
    }

    &__cancel {
      display: inline-block;
      vertical-align: middle;
      width: 25px;
      height: 25px;
      padding-top: 4px;

      font-size: 18px;
      line-height: 18px;
      color: $secondary-colour;

      background: $error-colour;

      border-radius: 50%;

      @include transition(background 0.2s ease-in-out);

      i {
        &:before {
          display: block;
        }
      }

      &:hover {
        background: darken($error-colour, 10%);
      }
    }

    table {
      width: 100%;
      border: 1px solid #ddd;
    }

    table td,
    table th {
      padding: 10px 5px;

      text-align: center;

      border-right: 1px solid #ddd;
    }

    table th {
      font-weight: bold;

      background: #f4f4f4;
    }

    table tr {
      background: $secondary-colour;
    }

    table tbody tr {
      border-bottom: 1px solid #ddd;
    }

    table tr.active {
      background: #7119ab;
      color: white;
    }
  }

  .qty_options {
    font-size: 0;
    > * {
      display: inline-block;
      vertical-align: middle;
      font-size: 1rem;
    }
    &__number {
      padding: 0 10px;
    }
    &__input {
        width: 60px;
        text-align: center;
        border: 1px solid;
        margin: 0 10px;
        border-radius: 5px;
        padding: 5px;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      &[type=number] {
        -moz-appearance: textfield;
      }
    }
    &__option {
      padding: 8px 8px;
      background: darken(#efefef, 5%);
      border-radius: 50%;
      transition: all 0.2s ease-in-out;
      user-select: none;
      cursor: pointer;
      &:hover {
        background: darken(#efefef, 50%);
        svg path,
        svg rect,
        svg polygon {
          fill: white;
        }
      }
      &--disabled {
        cursor: not-allowed;
        opacity: 0.4;
        &:hover {
          background: darken(#efefef, 5%);
          svg path,
          svg rect,
          svg polygon {
            fill: black;
          }
        }
      }
    }
  }
  .svg-seating {
    min-width: 360px;
    text-align: center;
  }
  .loader {
    background-color: rgba(255, 255, 255, 0.9);
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
  }
  .lds-grid {
    position: relative;
    margin: 0 auto;
    top: 33%;
    width: 80px;
    height: 80px;
  }
  .lds-grid div {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: $blue;
    animation: lds-grid 1.2s linear infinite;
  }
  .lds-grid div:nth-child(1) {
    top: 8px;
    left: 8px;
    animation-delay: 0s;
  }
  .lds-grid div:nth-child(2) {
    top: 8px;
    left: 32px;
    animation-delay: -0.4s;
  }
  .lds-grid div:nth-child(3) {
    top: 8px;
    left: 56px;
    animation-delay: -0.8s;
  }
  .lds-grid div:nth-child(4) {
    top: 32px;
    left: 8px;
    animation-delay: -0.4s;
  }
  .lds-grid div:nth-child(5) {
    top: 32px;
    left: 32px;
    animation-delay: -0.8s;
  }
  .lds-grid div:nth-child(6) {
    top: 32px;
    left: 56px;
    animation-delay: -1.2s;
  }
  .lds-grid div:nth-child(7) {
    top: 56px;
    left: 8px;
    animation-delay: -0.8s;
  }
  .lds-grid div:nth-child(8) {
    top: 56px;
    left: 32px;
    animation-delay: -1.2s;
  }
  .lds-grid div:nth-child(9) {
    top: 56px;
    left: 56px;
    animation-delay: -1.6s;
  }
  @keyframes lds-grid {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
}

.is-admin {
  @media (min-width: 1200px) {
    .container {
      margin: 0 auto;
    }
  }
}

.is-pos {

}

.picker--is-pos {
    tbody {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    tr {
      width: 100%;
      margin: 0.5rem;
      position: relative;
      display: block;
      background-color: #fff;
      border-radius: .5rem;
      box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .11), 0 5px 15px 0 rgba(0, 0, 0, .08);
      flex: 0 0 31%;
      min-height: 160px;
      padding: 1.25rem;
      @media (min-width: 1201px) {
        &:nth-child(3n) {
          margin-right: 0;
        }
        &:nth-child(3n+1) {
          margin-left: 0;
        }
      }
    }
    @media (max-width: 1200px) and (min-width: 801px) {
      tr {
        flex: 0 0 48%;
        &:nth-child(2n) {
          margin-right: 0;
        }
        &:nth-child(2n+1) {
          margin-left: 0;
        }
      }
    }
    @media (max-width: 800px) {
      tr {
        flex: 0 0 100%;
        margin-left: 0;
        margin-right: 0;
      }
    }
    table {
      td {
        display: block;
        flex: 1 0 100%;
        margin-bottom: 10px;
        text-align: left;
        &.price {
          margin-bottom: 70px;
        }
      }
    }
    .picker__remaining {
      display: none;
    }
    .picker__quantity {
      text-align: right;
      position: absolute;
      right: 80px;
      bottom: -10px;
    }
    .picker__add-ticket {
      width: auto !important;
      position: absolute;
      bottom: 0px;
      right: 5px;
    }
    .ticket-description {
      max-height: 200px;
      overflow: auto;
      font-size: 11px;
      margin: 10px 0;
    }
}
@media (max-width: 651px) {
  #tickets .detail__block {
    background: unset;
    border: unset;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/SeatPicker.vue